<mat-checkbox
  (click)="$event.stopPropagation()"
  color="primary"
  (change)="$event ? emailsPageStateService.selection.toggle(emailId) : null"
  [checked]="emailsPageStateService.selection.isSelected(emailId)">
</mat-checkbox>
